import * as swcHelpers from '@swc/helpers';

/**
 * Helper function to convert an array of objects in to an object that is
 * formatted correctly for the Select component
 * @param arr - Array of objects that will be turned into an object of objects
 * @param key - string that is used as key to lookup the value that will be used as labels(keys) in the returned object
 */ function createSelectOptions(arr = [], key) {
    return arr.reduce((acc, curr)=>swcHelpers.objectSpread({}, acc, {
            [String(curr[key])]: curr
        })
    , {});
}

export { createSelectOptions };
//# sourceMappingURL=create-select-options.js.map
